import { PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withTranslation } from 'react-i18next'
import { updateUser } from '../../actions/userInfo'
import { clearFilter, updateFilter } from '../../actions/filterInfo'
import LoadingMask from '../../components/LoadingMask'
import { HOST_NAME_PRODUCTION } from '../../constants'
import { auth, doLogin } from '../../utils/loginUtils'
import './index.css'

class LoginStaging extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            loginable: true
        }
    }

    componentDidMount() {
        const url = new URL(window.location.href)
        const searchParams = new URLSearchParams(url.search)
        const token = searchParams.get('code')
        if (token) {
            this.handleLogin(token)
        }
    }

    handleLogin = async (token) => {
        const { userInfoActions, filterInfoActions, history, t } = this.props
        await doLogin(token, {
            updateUser: userInfoActions.updateUser,
            updateFilter: filterInfoActions.updateFilter,
            history,
            t,
            onLoadingChange: (loading) => this.setState({ loading }),
            onLoginableChange: (loginable) => this.setState({ loginable })
        })
    }

    handleStagingLogin = () => {
        auth(this.state.loginable)
    }

    handleProductionLogin = () => {
        window.location.href = `${HOST_NAME_PRODUCTION}/loginiam`
    }

    render() {
        return (
            <div className="select-env-container">
                <h1 className="select-env-title">
                    環境選択
                    <span className="select-env-title-en">Select Environment</span>
                </h1>

                <div className="select-env-row">
                    <div className="select-env-card">
                        <p className="select-env-card-text-jp">
                            ユーザー研修やテストなどの社内利用のみに使用されます。
                        </p>
                        <p className="select-env-card-text-en">
                            This environment is used for internal purposes (user training, testing, etc.)
                        </p>
                        <hr className="select-env-card-divider" />
                        <div className="select-env-warning-header">
                            <span className="select-env-warning-icon">⚠</span>
                            <span className="select-env-warning-label">ご注意 (Warning)</span>
                        </div>
                        <p className="select-env-card-text-jp">
                            クライアント向けの調査・提案などの業務には使用できません。
                        </p>
                        <p className="select-env-card-text-en">It must not be used for client work!</p>
                    </div>
                    <button className="select-env-button select-env-button-staging" onClick={this.handleStagingLogin}>
                        to Staging
                    </button>
                </div>

                <div className="select-env-row">
                    <div className="select-env-card">
                        <p className="select-env-card-text-jp">
                            PD/PJに関連する業務ではこちらを使用します。
                            <br />
                            迷った場合はこちらの環境を選択してください。
                        </p>
                        <p className="select-env-card-text-en">
                            This environment can be used for any project or client work (proposals, analyses, client
                            research, etc.). When in doubt, use this environment.
                        </p>
                    </div>
                    <button
                        className="select-env-button select-env-button-production"
                        onClick={this.handleProductionLogin}
                    >
                        to Production
                    </button>
                </div>

                {this.state.loading && <LoadingMask />}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userInfo: state.userInfo,
        filterInfo: state.filterInfo
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        userInfoActions: bindActionCreators({ updateUser }, dispatch),
        filterInfoActions: bindActionCreators({ clearFilter, updateFilter }, dispatch)
    }
}

export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginStaging)))
